import {
  Receipt, FileText, Coins, Buildings, UsersThree, ChartPieSlice, Briefcase,
  Lightbulb, ClipboardText, BookOpenText, Calculator
} from "@phosphor-icons/react";

export const SERVICE_META = {
  GST: { Icon: Receipt, color: "#002FA7", desc: "Returns & reconciliation" },
  ITR: { Icon: FileText, color: "#00A86B", desc: "Income tax filing" },
  TDS: { Icon: Coins, color: "#F5A623", desc: "Deduction & returns" },
  ROC: { Icon: Buildings, color: "#0891B2", desc: "Company law filings" },
  Audit: { Icon: ClipboardText, color: "#DC2626", desc: "Statutory & internal audit" },
  Payroll: { Icon: UsersThree, color: "#DB2777", desc: "PF, ESI & salaries" },
  CMA: { Icon: ChartPieSlice, color: "#7C3AED", desc: "Bank & projections" },
  Bookkeeping: { Icon: BookOpenText, color: "#0F766E", desc: "Billing, ledgers & GST books" },
  Accounting: { Icon: Calculator, color: "#111111", desc: "Accounts & reconciliation" },
  Advisory: { Icon: Lightbulb, color: "#4B5563", desc: "Virtual CFO advisory" },
  Other: { Icon: Briefcase, color: "#9CA3AF", desc: "Assignments" },
};

export const SERVICE_LIST = ["GST", "ITR", "TDS", "ROC", "Audit", "Payroll", "CMA", "Bookkeeping", "Advisory"];

export const metaFor = (s) => SERVICE_META[s] || SERVICE_META.Other;

export const downloadBlob = (data, name) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  URL.revokeObjectURL(url);
};
